"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.form.title.edit': '编辑公司',
    'company.form.title.add': '添加公司',
    'company.form.back': '返回',
    'company.form.name.label': '公司名称',
    'company.form.name.placeholder': '输入公司名称',
    'company.form.nip.label': '税号',
    'company.form.nip.placeholder': '123-456-78-90',
    'company.form.email.label': '电子邮件',
    'company.form.email.placeholder': '地址@email.com',
    'company.form.phone.label': '电话',
    'company.form.phone.placeholder': '123 456 789',
    'company.form.address.label': '地址',
    'company.form.street.placeholder': '街道和门牌号',
    'company.form.postal_code.placeholder': '邮政编码',
    'company.form.city.placeholder': '城市',
    'company.form.website.label': '网站',
    'company.form.website.placeholder': 'https://公司.com',
    'company.form.description.label': '描述',
    'company.form.description.placeholder': '公司描述',
    'company.form.active.label': '活跃',
    'company.form.logo.label': '公司标志',
    'company.form.logo.placeholder': '选择公司标志',
    'company.form.submit.update': '更新',
    'company.form.submit.create': '保存',
    'company.form.submit.createCompanyData': '保存公司数据',
    'company.form.acl.loadError': '加载ACL元数据失败：',
    'company.form.load.error': '加载公司失败',
    'company.form.submit.updateError': '更新公司失败',
    'company.form.submit.createError': '创建公司失败',
    'company.form.submit.updateSuccess': '公司更新成功',
    'company.form.submit.createSuccess': '公司创建成功',
};
